// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "input.is-uppercase[data-v-33b6a5af] {\n  text-transform: uppercase;\n}\ninput.is-uppercase[data-v-33b6a5af]::-webkit-input-placeholder {\n  text-transform: none;\n}\ninput.is-uppercase[data-v-33b6a5af]::-moz-placeholder {\n  text-transform: none;\n}\ninput.is-uppercase[data-v-33b6a5af]:-moz-placeholder {\n  text-transform: none;\n}\ninput.is-uppercase[data-v-33b6a5af]:-ms-input-placeholder {\n  text-transform: none;\n}", ""]);
// Exports
module.exports = exports;
